module.exports = "/_next/static/images/7908f2826de6cfc96fad7a104d3eb4ad-girl-holding-card@lg.jpg";